import { Component, OnInit, NgModule, Input } from '@angular/core';
import { SideNavigationMenuModule, HeaderModule } from '../../shared/components';
import { ScreenService } from '../../shared/services';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { CommonModule } from '@angular/common';
import { AppInfoService } from '../../shared/services/app-info.service';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from '../../pages/home/home.component';
import { AuthGuardService } from '../../shared/services/auth.service';
import { FormItemControlService } from '../../services/form-item-control.service';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { DxButtonModule } from 'devextreme-angular/ui/button';

import { navigation } from '../../app-navigation';
import { Router, NavigationEnd } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { WorksheetComponent } from 'src/app/pages/worksheet/worksheet.component';

@Component({
  selector: 'app-side-nav-outer-toolbar',
  templateUrl: './side-nav-outer-toolbar.component.html',
  styleUrls: ['./side-nav-outer-toolbar.component.scss']
})
export class SideNavOuterToolbarComponent implements OnInit {
  menuItems = null;
  selectedRoute = '';

  menuOpened: boolean;
  temporaryMenuOpened = false;

  @Input()
  title: string;

  menuMode = 'shrink';
  menuRevealMode = 'expand';
  minMenuSize = 0;
  shaderEnabled = false;
  errorMsg: string;
  bIsError: boolean;

  constructor(private screen: ScreenService,
              private router: Router,
              private appInfoService: AppInfoService,
              private formItemControlService: FormItemControlService) {
  this.bIsError = false;
  this.errorMsg = '';

  this.formItemControlService.getFormErrorObservable().subscribe(bIsError => this.bIsError = bIsError);
  this.formItemControlService.getFormErrorMsgObservable().subscribe(msg => this.errorMsg = msg);

 }

  ngOnInit() {
    this.menuOpened = this.screen.sizes['screen-large'];

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        this.selectedRoute = val.urlAfterRedirects.split('?')[0];
      }
    });

    this.screen.changed.subscribe(() => this.updateDrawer());

    this.updateDrawer();

    this.populateNavigationMenu(false);
    this.router.navigate(['/home']);

    this.formItemControlService.getIsLoggedInObservable().subscribe(bIsLoggedIn => 
      {
        this.populateNavigationMenu(bIsLoggedIn);

        if (!bIsLoggedIn) {
          this.router.navigate(['/home']);
        }
      });
  }

  updateDrawer() {
    const isXSmall = this.screen.sizes['screen-x-small'];
    const isLarge = this.screen.sizes['screen-large'];

    this.menuMode = isLarge ? 'shrink' : 'overlap';
    this.menuRevealMode = isXSmall ? 'slide' : 'expand';
    this.minMenuSize = isXSmall ? 0 : 60;
    this.shaderEnabled = !isLarge;
  }

  get hideMenuAfterNavigation() {
    return this.menuMode === 'overlap' || this.temporaryMenuOpened;
  }

  get showMenuAfterClick() {
    return !this.menuOpened;
  }

  populateNavigationMenu(bIsLoggedIn: boolean) {
      this.menuItems = new Array();

      this.router.resetConfig([
        { path: 'home',
          component: HomeComponent
        }
      ]);

      this.menuItems.push({
        text: 'Home',
        path: '/home',
        icon: 'home'
      });

      if (bIsLoggedIn) {
        this.formItemControlService.setFormLoadingObservable(true);
        let userName = this.formItemControlService.loggedInUser;
  
        this.appInfoService.getWorksheets(this.formItemControlService.token, userName).subscribe(
        {
          next: (data: any[]) => {

            for (const item of data) {
              this.menuItems.push({
                text: item.ShortText,
                icon: 'placeholder',
                path: '/' + item.Path
              });

              this.router.config.push({
                path: item.Path,
                canActivate: [ AuthGuardService ],
                component: WorksheetComponent
            });
          }

            this.formItemControlService.setLoadedWorksheets(data);
          // this.menuItems.push(worksheets);

            this.formItemControlService.setFormErrorObservable(false, '');

             // Refresh the expiration date of the token
             this.formItemControlService.forceTokenRefresh();
          },
          error: (data: any) => {
            if (data != null) {
              if (data.status == 401) {
               this.formItemControlService.setFormErrorObservable(true, 'Logged off due to inactivity');
               this.formItemControlService.logoff();
              } else {
               this.formItemControlService.setFormErrorObservable(true, 'Failed to fetch the configured worksheets.  Error: ' + data.status + ', ' + data.statusText);
              }
            } else {
             this.formItemControlService.setFormErrorObservable(true, 'Failed to update the worksheet, unknown error');
            }

            this.formItemControlService.setFormLoadingObservable(false);
          }});
        }
    }

  navigationChanged(event) {
    const path = event.itemData.path;
    const pointerEvent = event.event;

    if (path && this.menuOpened) {
      if (event.node.selected) {
        pointerEvent.preventDefault();
      } else {
        this.router.navigate([path]);
      }

      if (this.hideMenuAfterNavigation) {
        this.temporaryMenuOpened = false;
        this.menuOpened = false;
        pointerEvent.stopPropagation();
      }
    } else {
      pointerEvent.preventDefault();
    }
  }

  getIsErrorCondition() {
    return this.bIsError;
  }

  getErrorMsg() {
    return this.errorMsg;
  }

  navigationClick() {
    if (this.showMenuAfterClick) {
      this.temporaryMenuOpened = true;
      this.menuOpened = true;
    }
  }

}

@NgModule({
  imports: [ SideNavigationMenuModule,
             DxDrawerModule,
             DxButtonModule,
             DxToolbarModule,
             HeaderModule,
             DxScrollViewModule,
             CommonModule,
             HttpClientModule ],
  exports: [ SideNavOuterToolbarComponent ],
  providers: [AuthGuardService],
  declarations: [ SideNavOuterToolbarComponent ]
})
export class SideNavOuterToolbarModule { }
